import { ref, Ref, computed } from 'vue'
import { useHistorySavedRef } from '../helpers'

export interface Paginator {
  page: number
  per: number
}

export function usePaginator(keyName: string, opts?: { page?: number; per?: number }) {
  const paginator: Ref<Paginator> = useHistorySavedRef(keyName, {
    page: opts?.page ?? 1,
    per: opts?.per ?? 10,
  })

  const count: Ref<number> = ref(0)

  const getPageCount = computed(() => {
    return Math.ceil(count.value / paginator.value.per)
  })

  const getPageFrom = computed(() => {
    return (paginator.value.page - 1) * paginator.value.per
  })

  const resetPage = () => {
    paginator.value.page = 1
  }

  return {
    paginator,
    count,
    getPageCount,
    getPageFrom,
    resetPage,
  }
}
